"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartyProperty = void 0;
class PartyProperty {
}
exports.PartyProperty = PartyProperty;
//# sourceMappingURL=PartyProperty.js.map